class Browser {
    IsIE() {
        return [
            window.navigator.userAgent.indexOf('MSIE'),
            window.navigator.userAgent.indexOf('Trident/')
        ].some(x => x > 0);
    }
}

export default new Browser();